$(function() {
    $('.btn-toggle-menu').click(function(e) {
        
        e.preventDefault();

        $(this).toggleClass('active');
        
        $('.toggle-menu').slideToggle();
    });

    
    if ( window.innerWidth < 1024 ) {
        $('.toggle-menu ul li a').click(function(e) {
            
            e.preventDefault();
    
            $('.btn-toggle-menu').removeClass('active');
            $('.toggle-menu').slideToggle();
        });
    }

});

